import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface InfoBubbleTitleProps {
  shouldWrapTitle?: boolean;
}

/*
 * Style.
 */

interface StyledTitleDivProps {
  $shouldWrap: boolean;
}

const StyledTitleDiv = styled.div<StyledTitleDivProps>`
  margin-bottom: 10px;
  ${(p) => (p.$shouldWrap ? null : ellipsis())};
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.veryLarge};
  color: ${(p) => p.theme.greys.shade90};
`;

/*
 * Component.
 */

export const InfoBubbleTitle: FC<PropsWithChildren<InfoBubbleTitleProps>> = (props) => (
  <StyledTitleDiv $shouldWrap={props.shouldWrapTitle ?? false}>{props.children}</StyledTitleDiv>
);
